export const fonts = `
  @font-face {
    font-family: SpaceGroteskLight;
    font-weight: lighter;
    src: url("./fonts/SpaceGrotesk-Light.ttf");
  }
  @font-face {
    font-family: SpaceGroteskRegular;
    font-weight: normal;
    src: url("./fonts/SpaceGrotesk-Regular.ttf");
  }
  @font-face {
    font-family: SpaceGroteskBold;
    font-weight: bold;
    src: url("./fonts/SpaceGrotesk-Bold.ttf");
  }

  @font-face {
    font-family: PlayfairDisplay-Italic;
    font-weight: italic;
    src: url("./fonts/PlayfairDisplay-Italic-VariableFont_wght.ttf");
  }

  @font-face {
    font-family: PlayfairDisplay;
    font-weight: normal;
    src: url("./fonts/PlayfairDisplay-VariableFont_wght.ttf");
  }

`;
